import type { LedgerSafeEditSuggestion } from './ledgerSafeEditSuggestionTypes'
import { shouldSkipLedgerSafeSuggestion } from './ledgerSafeEditSuggestionEvents'

export const canCollectMoreLedgerSafeSuggestions = (
  suggestions: LedgerSafeEditSuggestion[],
  maxSuggestions: number
): boolean => suggestions.length < maxSuggestions

export const collectLedgerSafeEditSuggestion = ({
  suggestions,
  suggestion,
  dismissedIds,
  appliedKeys
}: {
  suggestions: LedgerSafeEditSuggestion[]
  suggestion: LedgerSafeEditSuggestion | null
  dismissedIds: Set<string>
  appliedKeys: Set<string>
}): boolean => {
  if (!suggestion || shouldSkipLedgerSafeSuggestion({ suggestion, dismissedIds, appliedKeys })) {
    return false
  }
  if (suggestions.some(existing => existing.id === suggestion.id)) {
    return false
  }
  suggestions.push(suggestion)
  return true
}

export const collectLedgerSafeEventSuggestions = ({
  suggestions,
  candidateSuggestions,
  dismissedIds,
  appliedKeys,
  maxSuggestionsPerEvent
}: {
  suggestions: LedgerSafeEditSuggestion[]
  candidateSuggestions: Array<LedgerSafeEditSuggestion | null>
  dismissedIds: Set<string>
  appliedKeys: Set<string>
  maxSuggestionsPerEvent: number
}): number => {
  let added = 0
  candidateSuggestions
    .filter((suggestion): suggestion is LedgerSafeEditSuggestion => Boolean(suggestion))
    .sort((left, right) => right.contentScore - left.contentScore)
    .slice(0, maxSuggestionsPerEvent)
    .forEach(suggestion => {
      if (collectLedgerSafeEditSuggestion({ suggestions, suggestion, dismissedIds, appliedKeys })) {
        added += 1
      }
    })
  return added
}

export const finalizeLedgerSafeEditSuggestions = (
  suggestions: LedgerSafeEditSuggestion[],
  maxSuggestions: number
): LedgerSafeEditSuggestion[] => suggestions.slice(0, maxSuggestions)
